import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonContextMenuStart } from "../generic/common/ButtonContextMenuStart";
import { ButtonNormalSmall } from "../generic/common/ButtonNormalSmall";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
export var ContextMenuBuffButton = React.memo(function (_a) {
    var recipe = _a.recipe, onBoostProduction = _a.onBoostProduction, building = _a.building;
    var ButtonComponent = recipe === undefined ? ButtonNormalSmall : ButtonContextMenuStart;
    return (React.createElement(TooltipText, { className: "context-menu-button-buff", id: IdLoca.tooltip_useHumus_web, anchor: IdTooltipAnchor.Bottom },
        React.createElement(ButtonComponent, { onClick: function () { return onBoostProduction(building, recipe); }, disabled: recipe === undefined },
            React.createElement("div", { className: "w100 h100 flex flex--guts" },
                React.createElement(Icon, { icon: IdIcon.ProductionIcn, styleId: IdStyles.IconLarge })))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/ContextMenuBuffButton.tsx
// module id = 2244
// module chunks = 3